// ink-component
import React from 'react';
import Pagination from '../LedgerWrapperPagination/LedgerWrapperPagination';
import { PaginationProps as CorePaginationProps } from '../../../Pagination/Pagination';

export interface BottomBarProps extends CorePaginationProps {
  /** Object representing which rows have been selected. Comes from useLedger or useSelectable hook. */
  rows: Record<string, unknown>;
}

/**
 * @purpose Ledger bottom bar, complete with conditional rendering logic
 * @categories table
 * @group ledger
 */
const BottomBar = (props: BottomBarProps) => {
  const { rows, ...otherProps } = props;
  const rowsAreSelected = Boolean(Object.entries(rows).filter(([key, val]) => val).length);
  return rowsAreSelected ? null : <Pagination {...otherProps} />;
};

BottomBar.displayName = 'LedgerWrapper.BottomBar';

export default BottomBar;
